import { LabelValueForText } from "components/ui/atoms/LabelValue";
import { getCommons } from "./fieldConverterHelpers";

import { Link } from "@mui/material";
import { useCallback } from "react";
import NiceModal from "@ebay/nice-modal-react";

export const LinkCell = ({ id, formattedValue, ...props }) => {
  const { model } = props.colDef._meta;

  const handleClick = useCallback(() => {
    return NiceModal.show(model.viewModal, { id: id, path: `${id}` });
  }, [model, id]);

  return (
    <Link
      component={"button"}
      underline="hover"
      color="inherit"
      onClick={handleClick}
    >
      {formattedValue}
    </Link>
  );
};

export const LinkFieldView = ({ field, formattedValue }) => {
  return (
    <LabelValueForText
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      value={formattedValue || ""}
      isMissing={
        formattedValue === undefined ||
        formattedValue === null ||
        formattedValue.toString().trim() === ""
      }
    />
  );
};

export const linkFieldConverter = ({ field, model }) => {
  return {
    ...getCommons({ field, model }),
    type: "string",
    renderCell: LinkCell,
    disableClickEvent: true,
  };
};
